import ServiceBase from '@/services/BasicServiceBase';

const resource = 'rest-auth';

class RestAuthService extends ServiceBase {
  constructor() {
    super({ resource });
  }

  requestPasswordReset = (passwordResetForm) => {
    const action = 'password/reset';
    const url = `${this.resource}${action}/`;
    const response = this.http.post(url, passwordResetForm);
    return response;
  }

  resetPassword = (passwordResetForm) => {
    const action = 'password/reset/confirm';
    const url = `${this.resource}${action}/`;

    const data = {
      ...passwordResetForm,
      new_password1: passwordResetForm.password,
      new_password2: passwordResetForm.repeatPassword,
    };
    delete data.password;
    delete data.repeatPassword;
    const response = this.http.post(url, data);
    return response;
  }
}

export default RestAuthService;



// WEBPACK FOOTER //
// ./src/services/RestAuthService.js